import { RootState } from "../rootReducer"

export const selectCurrentNotification = (state: RootState) => state.notifications.current
export const selectStackNotifications = (state: RootState) => state.notifications.stack
export const selectNewsStackNotifications = (state: RootState) => state.notifications.newsStack
export const selectNotificationsListState = (state: RootState) => state.notifications.isContainerOpen
export const selectNewsState = (state: RootState) => state.notifications.newsState
export const selectDeleteNewsState = (state: RootState) => state.notifications.deleteNewsState
